import { AnalitycsEvent } from '../models/analytics-event.model';
import { CitydealsEvent } from '../models/citydeals-event.model';
import { EventProduct } from '../models/event-product.model';

export class ProductClickEvent implements CitydealsEvent {
  static eventName = 'productClick';
  private userId: number | 'unknown';
  private product: EventProduct;

  constructor(userId: number | null, product: EventProduct) {
    this.userId = userId ?? 'unknown';
    this.product = product;
  }

  getEvent(): AnalitycsEvent {
    return {
      event: ProductClickEvent.eventName,
      userId: this.userId,
      ecommerce: {
        click: {
          products: [this.product],
        },
      },
    };
  }
}
